import SubmitButton from "./SubmitButton";
import GoBackButton from "./GoBackButton";
import CloseButton from "./CloseButton";
import CancelButton from "./CancelButton";

export
{
    SubmitButton,
    GoBackButton,
    CloseButton,
    CancelButton
}